import request from '@/utils/request';

export function login(username, password) {
  return request({
    url: '/login/login',
    method: 'post',
    data: {
      username: username,
      password: password
    }
  });
}

export function getInfo(token) {
  return request({
    url: '/user/info',
    method: 'get',
    params: {
      token: token
    }
  });
}

export function logout() {
  return request({
    url: '/login/loginOut',
    method: 'post'
  });
}